export default [
    {
        path: '/admin/security/history-logs',
        name: 'history-logs',
        meta: { requiresAuth: true },
        component: () => import('@/pages/security/history-log/index.vue')
    }
]
